/**
 * Provides global window object as a module in order to
 * make it injectable and possible to mock in unit tests.
 */
export default window;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/base/Window.js
// module id = 1881
// module chunks = 0